<div class="input-wrapper">
  <input
    [type]="type"
    #inputFef
    (blur)="blur.emit()"
    [(ngModel)]="value"
    [placeholder]="placeholder"
    class="lib-cm-input"
    spellcheck="false"
    [disabled]="disabled"
    [ngClass]="{
      clearable: clearable,
      'border-highlighted': !!val && highlightIfSet
    }"
    [mask]="ngxMask"
    [prefix]="ngxPrefix"
    [suffix]="ngxSuffix"
    [thousandSeparator]="ngxThousandSeparator"
    [decimalMarker]="ngxDecimalMarker"
    [dropSpecialCharacters]="ngxDropSpecialCharacters"
    [allowNegativeNumbers]="ngxAllowNegativeNumbers"
    [patterns]="hasCustomPatterns ? ngxPatterns : null"
    (focus)="onfocus($event)"
    [maxlength]="maxlength"
    [restrictPattern]="restrictPattern"
    />

  @if (!!val && clearable) {
    <span class="reset-btn" id="atqa-reset-btn" (click)="reset()" id="atqa-reset-btn">
      <i class="material-icons" [class.highlighted]="highlightIfSet">close</i>
    </span>
  }
</div>
